import { ColumnType } from "../../types/dataGridTypes";

const useSiteLabVendorsColumns = () => {
  const reportsListColumns: ColumnType[] = [
    {
      field: "id",
      headerName: "ID",
      minWidth: 120,
      flex: 1,
      cmp: "link",
      linkPermission: "VIEW_STUDY_DETAILS",
      badge: true,
    },
    {
      field: "name",
      headerName: "Name",
      width: 160,
    },
    {
      field: "country",
      headerName: "Country",
      width: 160,
    },
    {
      field: "city",
      headerName: "City",
      width: 120,
    },
    {
      field: "type",
      headerName: "Type",
      minWidth: 120,
      flex: 1,
    },
    {
      field: "studyID",
      headerName: "Study ID",
      minWidth: 180,
      cmp: "link",
      linkPermission: "VIEW_STUDY_DETAILS",
    },
    {
      field: "actionsColumn",
      width: 90,
      type: "actions",
      cmp: "actions",
      headerName: "Action",
      sortable: false,
      filterable: false,
      actionsArray: [
        { icon: "Edit", label: "Edit", key: "action_edit" },
        { icon: "Delete", label: "Delete", key: "action_delete" },
      ],
    },
  ];
  return reportsListColumns;
};

export default useSiteLabVendorsColumns;
